import { FOOD_BENEFIT_STATES } from 'common/domain/constants';

export default class foodBenefitCard {

  constructor(cardInitialData) {
    this.id = cardInitialData.id || '';
    this.enjoymentDays = cardInitialData.enjoymentDays || 0;
    this.enjoymentMonth = cardInitialData.enjoymentMonth || 0;
    this.enjoymentYear = cardInitialData.enjoymentYear || new Date().getFullYear();
    this.maximumNumberDaysPerMonth = cardInitialData.maximumNumberDaysPerMonth || 0;
    this.remarks = cardInitialData.remarks || '';
    this.state = cardInitialData.status || FOOD_BENEFIT_STATES.initial;
    this.requestErrorMsg = '';
  }

}



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/domain/models/foodBenefitCard.js